var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateNewFolder = function SvgCreateNewFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "create_new_folder_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#create_new_folder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h5.175a1.98 1.98 0 0 1 1.4.575L12 6h8q.824 0 1.413.588Q22 7.175 22 8v10q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm0-2h16V8h-8.825l-2-2H4zm10-4v1q0 .424.287.713.288.287.713.287.424 0 .713-.287A.97.97 0 0 0 16 15v-1h1q.424 0 .712-.287A.97.97 0 0 0 18 13a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 12h-1v-1a.97.97 0 0 0-.287-.713A.97.97 0 0 0 15 10a.97.97 0 0 0-.713.287A.97.97 0 0 0 14 11v1h-1a.97.97 0 0 0-.713.287A.97.97 0 0 0 12 13q0 .424.287.713.288.287.713.287z"
  }))));
};
export default SvgCreateNewFolder;